module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter1"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "pg_17_2",
      "src": "images/pg_17_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The M13/40, designed to replace the Italian L3, L6/40 and M11/39, was a much better tank but suffered the same reliability problems as well as insufficient armament and armour. While the 47mm gun could handle British light and Cruiser tanks, it could not deal with anything heavier. The sandbags heaped on the front of the hull were a crude way of supplementing the 40mm armour. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Australian Army")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a3e03d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_07_Chapter1.vue
// module id = 96
// module chunks = 0